import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { IconCheckInput } from '@/presentation/components/icons';
import Styles from './KVcheck-box-styles.scss';
const Checkbox = ({ error, defaultChecked = false, name, onChange: onChangeParam, inputWrapItem, readOnly = false, overrideIcon }) => {
    const [checked, setChecked] = useState(defaultChecked);
    useEffect(() => {
        if (onChangeParam)
            onChangeParam(checked);
    }, [checked]);
    return (React.createElement("div", { "data-testid": `${name}-wrap`, className: `${Styles.inputWrapCustom}`, onClick: () => !readOnly && setChecked(!checked), id: 'checkbox' },
        React.createElement("div", { className: classNames(Styles.inputWrapItem, checked ? Styles.checked : '', inputWrapItem) }, checked && React.createElement("span", null, overrideIcon || React.createElement(IconCheckInput, null))),
        error && React.createElement("span", { className: Styles.spanError }, error),
        React.createElement("input", { type: "checkbox", name: name, style: { display: 'none' }, checked: checked, readOnly: true })));
};
export default Checkbox;
